export default __webpack_public_path__ + "static/media/entericon_light.2cdddf74.svg";